<template>
  <div class="review-sidebar-component is-fullheight">
    <div class="box is-full is-fixed-top">
      <div class="is-relative">
        <div class="columns pt-6 pl-6">
          <div class="column is-4">
            <div class="columns">
              <div class="column is-8">
                <h1 class="is-size-2 has-text-weight-bold">
                  Seu plano
                </h1>
              </div>
              <div class="column is-4 is-flex is-align-items-center">
                <button
                    class="button is-primary tooltip-button is-right has-tooltip-multiline has-tooltip-left"
                    data-tooltip="O valor final cobrado para a contratação de seu plano, expresso no boleto ou na fatura de seu cartão, poderá ser menor, devido a política tributária da Pedbot, que trabalha com retenção de alguns impostos no tomador dos serviços. Caso tenha dúvidas, contacte nossa equipe ou fale com o vendedor"
                >
                  ?
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="pl-6 box-scroll-content">
          <div class="columns mt-6">
            <div class="column is-12">
              <steps
                  ref="reviewSteps"
                  :formData="formData"
              ></steps>
            </div>
          </div>
          <hr class="is-box-width">
          <div class="columns mt-2 is-box-width">
            <div class="column is-12">
              <review-extra-services
                  :formData="formData"
                  :steps="steps"
              ></review-extra-services>
            </div>
          </div>
          <hr class="is-box-width">
          <div class="columns mt-2 is-box-width">
            <div class="column is-12">
              <sum-description
                  :formData="formData"
                  :steps="steps"
                  :onlyUnique="false"
              ></sum-description>
            </div>
          </div>
        </div>
        <div class="columns pl-6 mt-2 is-box-width is-fixed-bottom" v-if="AppStoreStore.showReviewNextButton">
          <div class="column">
            <next-button
              @nextTab="$emit('nextTab')"
              position="center"
              sizeClass="is-fullwidth"
            ></next-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Steps from "./Steps/Index";
import NextButton from "../Tabs/NextButton";
import SumDescription from "./SumDescription/Index";
import ReviewExtraServices from "./ReviewExtraServices/Index";
import {useAppStore} from "@/stores/AppStore";
import {mapStores} from 'pinia'

export default {

  name: 'review-sidebar',

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      steps: [],
      totalExtraServicesPrice: 0
    }
  },

  components: {
    NextButton,
    Steps,
    SumDescription,
    ReviewExtraServices
  },

  computed: {
    ...mapStores(useAppStore)
  },

  mounted () {
    this.$watch(
      () => {
        return this.$refs.reviewSteps.steps
      },
      () => {
        this.populateSteps()
      }
    )
    this.populateSteps()
    this.calculateTotalExtraServicesPrice()
  },

  methods: {
    populateSteps() {
      this.steps = this.$refs.reviewSteps.steps
    },
    parseExtraServicePrice(extraService) {
      return parseFloat(extraService.price) * extraService.quantity
    },
    calculateTotalExtraServicesPrice() {
      let total = 0
      for (const extraService of this.formData.extraServices.data) {
        total += this.parseExtraServicePrice(extraService)
      }
      this.totalExtraServicesPrice = total
    }
  }

}

</script>

<style lang="scss" scoped>
.review-sidebar-component {
  &.is-fullheight {
    height: 100%;
  }

  .box {
    border-radius: 0px;
    background-color: white;
    box-shadow: -8px 0.4em 0.5em -0.3em rgb(10 10 10 / 30%), 0 0px 0 1px rgb(10 10 10 / 2%);
    z-index: 1030;
    margin-top: 0 !important;
    padding-top: 0 !important;

    &.is-full {
      height: 100vh;
      width: 100vw;
    }

    &.is-fixed-top {
      position: fixed;
      top: 0;
      bottom: 0;
      overflow-y: scroll;
      overflow-x: hidden;
    }

    .is-box-width {
      width: 30%;
    }

    .is-fixed-bottom {
      position: absolute;
    }

    .box-scroll-content {
      max-height: 70vh;
      overflow-y: scroll;
      overflow-x: hidden;
    }

    hr {
      border: none;
      height: 3px;
      color: #dae6ec;
      background-color: #dae6ec;
    }
  }
}
</style>